import React, { type FC } from 'react';
import PropTypes from 'prop-types';

import { Link } from '@confluence/route-manager/entry-points/Link.ts';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';
import { isTeamsAppEnabled } from '@confluence/teams-app-config/entry-points/isTeamsAppEnabled.ts';

export const PeopleLink: FC<any> = (props) => {
	const { href, to, children, ...otherProps } = props;
	const url = to || href;
	const path = url && url.indexOf('/') !== 0 ? `/${url}` : url;
	const destination = !path.startsWith(CONTEXT_PATH) ? `${CONTEXT_PATH}${path}` : path;

	return (
		<Link href={isTeamsAppEnabled() ? url : destination} to={to} {...otherProps}>
			{children}
		</Link>
	);
};

PeopleLink.propTypes = {
	href: PropTypes.string,
	to: PropTypes.string,
};
